<template>
    <div class="fwpj">
        <div class="title">
            <span>服务评价</span> 
                <div class="close">
                    <el-button type="text" icon="el-icon-close" @click="close()" ></el-button>
                </div>
        </div>
        <div class="text">
            
            <div >
                尊敬的用户：
            </div>
            <div class="wenhou">
                您好，为了更好的推进我们的服务工作，特邀请您对于在发标及开评标阶段我司工作人员的服务表现进行评价，您的评价对我们非常重要，烦请您如实填写，谢谢您的理解。
            </div>
            <div class="fw">
                <div class="left">
                    服务评价
                </div>
                <div class="right">
                    满意请给5星哦
                </div>
            </div>
            <div class="fbjd">
                <div class="fabiao">
                    发标阶段
                </div> 
                     
                <div class="rate">
                    <el-rate v-model="fbcurScore"  :texts="texts" show-text disabled ></el-rate>

                </div>
                <div class="xuanxiang" v-if="fbcurScore<=3">
                    <ul class="box" >
                        <li v-for="(item,index) of fbitems"

                            :class="{checked:item.bOn}"
                            :key = "index">{{item.name }}
                        </li>
                    </ul>
                 
                    <!-- <el-input 
                        v-model="qita" 
                        type="textarea" 
                        :autosize="{ minRows: 2, maxRows: 4}"
                        placeholder="
                        请填写在发标阶段遇到的问题，这将帮助我们为您提供更好的服务..."
                        v-if="fbqita==true">
                    </el-input> -->
                    <el-input
                        v-model="qita" 
                        type="textarea"
                         :autosize="{ minRows: 2}"
                        placeholder="请填写在发标阶段遇到的问题，这将帮助我们为您提供更好的服务..."
                        v-if="fbqita==true"
                        disabled
                       >
                    </el-input>               
      

                   
                </div>
            </div>

            <div class="kpbjd">
                <div class="fabiao"> 
                    开评标阶段
                </div>
               
                <div class="rate">
                    <el-rate  v-model="kpbcurScore" :texts="kpbtexts" show-text  disabled ></el-rate>
                </div>
                <div  class="xuanxiang" v-if="kpbcurScore<=3">
                    <ul class="boxkpb" >
                        <li v-for="(item,index) of kpbitems"
                            :class="{checked:item.bOn}"
                            :key = "index">{{item.name }}
                        </li>
                    </ul>
                   
                    <el-input 
                    v-model="kpb_qita" 
                    type="textarea" 
                     :autosize="{ minRows: 2}"
                    placeholder="请填写在发标阶段遇到的问题，这将帮助我们为您提供更好的服务..."
                    v-if="kpbqita==true"
                    disabled
                    >
                    </el-input>
                </div>
              
          
                <div class="beizhu" v-if="phonenumber!==''">
                     
                    <el-radio v-model="radio" :label="3">需要客服联系我，了解服务过程的详细情况！</el-radio>
                    <div v-if="radio===3" class="xianshi">
                    <!-- <span>
                        电话号码：    
                    </span> -->
                    <!-- <div class="dhhm">
                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" >
                        <el-form-item label="电话号码" prop="phonenumber">
                            <el-input v-model="ruleForm.phonenumber" disabled></el-input>
                        </el-form-item>
                    </el-form>
                    </div> -->
                    <div class="dhhm">
                        <el-form label-width="80px" >
                            <el-form-item label="电话号码" prop="phonenumber">
                                <el-input v-model="phonenumber" disabled ></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
       
                    </div>
                </div>
                
            </div>
           
        </div>
    </div>
</template>

<script>
 
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

export default {
    mixins: [LIST_PAGE_MIXIN],
    props: {
		xianshi: {
			type: Boolean,
			default: false
		},
        bdcode: {
			type: String,
			default: ''
		},
        bdname: {
			type: String,
			default: ''
		},
        zbprocode: {
			type: String,
			default: ''
		},
        zbproname: {
			type: String,
			default: ''
		},
	},

    data() {
        return{
            pjxianshi:false,
            istrue_fb:0,
            istrue_kpb: 0,
            fbcurScore:0,
            kpbcurScore:0,
            fbList:[],
            kpbList:[],
            qita:'',
            fbservicescore:{
                jdlabel:'',
                jdscore:0,
                jdtype:'',
                jdcontent:'',
                jdcontentdetail:'',
                bdcode:'',
           
            },
            kpbservicescore:{
                jdlabel:'',
                jdscore:0,
                jdtype:'',
                jdcontent:'',
                jdcontentdetail:'',
                bdcode:'',
          
            },
            texts: ['非常差', '差', '一般', '满意', '非常满意'],
            kpbtexts:['非常差', '差', '一般', '满意', '非常满意'],
          
            kpb_qita:'',
            detail_xianshi:false,
            fbxianshi:'',
            kpbxianshi:'',
            fbqita:'',
            kpbqita:'',
            // score:2,
            kpbitems: [
                {name:'开标支持迟到',bOn:false},
                {name:'长时间玩手机',bOn:false},
                {name:'缺乏沟通',bOn:false},
                {name:'态度不端正',bOn:false},
                {name:'擅自离岗',bOn:false},
                {name:'专业能力弱',bOn:false},
                {name:'其他',bOn:false},
            ],
            fbitems: [
                {name:'问题回答不专业',bOn:false},
                {name:'演示不熟练',bOn:false},
                {name:'解决问题能力弱',bOn:false},
                {name:'态度恶劣',bOn:false},
                {name:'其他',bOn:false},
            ],
            radio: '',
            phonenumber:'',
            fb_checklist:[],
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
         checkMobile :(rule, value, cb) => {
            // 验证手机号的正则表达式
            const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
            if (regMobile.test(value)) {
               return cb()
            }
            cb(new Error('请输入合法的手机号'))
     },
        checkbox(i){
            this.fbservicescore.jdlabel='发标阶段' 
            this.fbservicescore.jdtype='1'
            this.fbqita=false
            this.fbList=[]
            this.fbitems[i].bOn = !this.fbitems[i].bOn;
            var that=this
            this.fbitems.forEach(function(item){
                if(item.bOn==true) {
                    that.fbList.push(item)   
                }
            })
            var fbname=[]
            this.fbList.forEach(function(item){
                fbname.push(item.name)
                that.fbservicescore.jdcontent=fbname.join(',')
                if(item.name=='其他') {
                    that.fbqita=true
                }        
            })
            this.fbservicescore.jdcontentdetail=this.qita
        },
        checkkpbbox(i){
            this.kpbservicescore.jdlabel='开评标阶段'
            this.kpbservicescore.jdtype='2'
            this.kpbqita=false
            this.kpbList=[]
            this.kpbitems[i].bOn = !this.kpbitems[i].bOn;
            var that=this
            this.kpbitems.forEach(function(item){
                if(item.bOn==true) {
                    that.kpbList.push(item) 
                }
            })
            var kpbname=[]
            this.kpbList.forEach(function(item){
                kpbname.push(item.name)
                that.kpbservicescore.jdcontent=kpbname.join(',')
                if(item.name=='其他') {
                    that.kpbqita=true
                }             
            })
            this.kpbservicescore.jdcontentdetail=this.kpb_qita
        },
        close(){
            this.detail_xianshi=false
            this.$emit('closeDetail',this.detail_xianshi)
        },
        clickitem (e) {
            e === this.radio ? this.radio = '' : this.radio= e
        },
        fbchangeScore(val){
            this.fbservicescore.jdtype='1'
            this.fbservicescore.jdlabel='发标阶段'
            this.fbservicescore.bdcode=this.bdcode
            this.fbxianshi=true
            this.$nextTick(() => {
                this.fbcurScore=val          
                this.fbservicescore.jdscore=this.fbcurScore
            })
        },
        kpbchangeScore(val){
            this.kpbservicescore.jdlabel='开评标阶段'
            this.kpbservicescore.bdcode=this.bdcode
            this.kpbservicescore.jdtype='2'
            this.kpbxianshi=true
            
            this.$nextTick(() => {
                this.kpbcurScore=val              
                this.kpbservicescore.jdscore=this.kpbcurScore
            })
        },
    },
    created() {
         this.$get(`${this.getGetters('mngUrl')}/service/pj/detailpj.json`,{
            bdcode:this.bdcode.split(',')[0]
        }, (data, res) => {
            this.fbcurScore=data.t_servicescorejd[0].jdscore
            this.kpbcurScore=data.t_servicescorejd[1].jdscore
            this.qita=data.t_servicescorejd[0].jdcontentdetail
            this.kpb_qita=data.t_servicescorejd[1].jdcontentdetail
            this.phonenumber=data.phone
            this.fbservicescore=data.t_servicescorejd[0]
            this.kpbservicescore=data.t_servicescorejd[1]
            this.groupcode=data.groupcode
            
            if(this.kpbservicescore.jdscore>=3.5) {
                this.radio=''
            }
            if(this.phonenumber!=='') {
                this.radio=3
            }
            if(data.t_servicescorejd[0].jdcontent!==null&&data.t_servicescorejd[0].jdcontent!=='') {
                for(var i=0;i<data.t_servicescorejd[0].jdcontent.split(',').length;i++) {
                    for(var j=0;j<this.fbitems.length;j++) {
                        if(this.fbitems[j].name==data.t_servicescorejd[0].jdcontent.split(',')[i]) {
                            this.fbitems[j].bOn=true
                            if(j==4) {
                                this.fbqita=true
                                
                            }
                            // if(data.t_servicescorejd[0].jdscore<=3) {
                            //     this.radio=3
                            // }
                        }
                    }
                }
            }
            if(data.t_servicescorejd[1].jdcontent!==null&&data.t_servicescorejd[1].jdcontent!=='') {
                for(var i=0;i<data.t_servicescorejd[1].jdcontent.split(',').length;i++) {    
                    for(var j=0;j<this.kpbitems.length;j++) {
                        if(this.kpbitems[j].name==data.t_servicescorejd[1].jdcontent.split(',')[i]) {
                            this.kpbitems[j].bOn=true
                            if(j==6) {
                                this.kpbqita=true
                              
                            }
                            // if(data.t_servicescorejd[1].jdscore<=3) {
                            //     this.radio=3
                            // }
                        }
                    }
                }
            }
                
            

        })
        // this.$get(`${this.getGetters('mngUrl')}/service/pj/detailpj.json`,{
        //     bdcode:this.bdcode.split(',')[0]
        // }, (data, res) => {
        //     this.fbcurScore=data.t_servicescorejd[0].jdscore
        //     this.kpbcurScore=data.t_servicescorejd[1].jdscore
        //     this.qita=data.t_servicescorejd[0].jdcontentdetail
        //     this.kpb_qita=data.t_servicescorejd[1].jdcontentdetail
        //     this.phonenumber=data.phone
        //     if(data.t_servicescorejd[0].jdcontent!==null&&data.t_servicescorejd[0].jdcontent!=='') {
        //         for(var i=0;i<data.t_servicescorejd[0].jdcontent.split(',').length;i++) {
        //             for(var j=0;j<this.fbitems.length;j++) {
        //                 if(this.fbitems[j].name==data.t_servicescorejd[0].jdcontent.split(',')[i]) {
        //                     this.fbitems[j].bOn=true
        //                     if(j==4&&data.t_servicescorejd[0].jdscore<=3.5) {
        //                         this.fbqita=true
        //                         this.radio=3
        //                     }
        //                 }
        //             }
        //         }
        //     }
        // // } 
        // // console.log(data.t_servicescorejd[1].jdcontent!==null)
        //     if(data.t_servicescorejd[1].jdcontent!==null&&data.t_servicescorejd[1].jdcontent!=='') {
        //         for(var i=0;i<data.t_servicescorejd[1].jdcontent.split(',').length;i++) {    
        //             for(var j=0;j<this.kpbitems.length;j++) {
        //                 if(this.kpbitems[j].name==data.t_servicescorejd[1].jdcontent.split(',')[i]) {
        //                     this.kpbitems[j].bOn=true
        //                     if(j==6&&data.t_servicescorejd[1].jdscore<=3.5) {
        //                         this.kpbqita=true
        //                         this.radio=3
        //                     }
        //                 }
        //             }
        //         }
        //     }
            
        // })
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
.fwpj {
    width: 47%;
    height: 90%;
    margin: auto;
    // background-color: rgb(197, 184, 184);
    border-radius: 5px;
    overflow: auto;
    position: absolute;
    top: 0;
    z-index: 3000;
    left: 25%;
    background-color: #fff
}
.fw {
    width: 100%;
    margin-bottom: 3%;
    height: 20px;
}
.title {
    height: 45px;
    line-height: 45px;
    color: #fff;
    // float: left;
    padding-left: 10px;
    background-color: rgba(251, 115, 98, 1);
}
.text {
    padding:2%;
    font-size: 14px;
    // letter-spacing:0px;
}
.wenhou {
    margin-top:10px;
    text-indent:28px;
    margin-bottom:5%;
}
.left {
    float: left;
    font-weight: 700;
    margin-bottom: 10px;
    // width: 100%;

}
.right {
    float: right;
    color: #7F7F7F;
     margin-bottom: 10px;
}
.kpbjd {
    margin-bottom: 10px;
    margin-top: 2%;
}
.kpbjd .active {
    background-color: rgba(251, 115, 98, 1);
    color: #fff
    }
.kpbjd  ul li {
    float: left;
    margin-right: 3%;
    margin-bottom: 1%;
    list-style-type: none;
    width: 15%;
    padding: 1%;
    line-height: 30px;
    text-align: center;
    background: inherit;
    border-radius: 10px;
    cursor: pointer;
    background-color: rgba(242, 242, 242, 1);
    }
.kpbjd ul {
    margin-bottom: 10px;
    }
.fbjd ul li {
    float: left;
    margin-right: 3%;
    margin-bottom: 1%;
    list-style-type: none;
    padding: 1%;
    width: 15%;
    line-height: 30px;
    text-align: center;
    background: inherit;
    border-radius: 10px;
    cursor: pointer;
    background-color: rgba(242, 242, 242, 1);
    }   
.fbjd .active {
    background-color: rgba(251, 115, 98, 1);
    color: #fff
    } 
.fbjd {
    font-size:14px;
    // height: 169px;
    // margin-bottom: 70px;
    }
.dhhm {
    width: 45%;
    margin-right: 30%;
    float: left;
    }
.xuanxiang {
    width: 100%;
    padding-bottom: 1%;
 
}
.lxfs {
    color:#D9001B;
    float:left;
    margin-top:15px;
}
.xianshi {
    margin-top: 10px;
}
ul{
    padding:0; 
    list-style:none;
}
.box {
    width: 100%;
}
.boxkpb {
    height:100px ;
}
.box .checked{ 
    background-color: rgba(251, 115, 98, 1);
    color: #fff}
.boxkpb .checked{ 
background-color: rgba(251, 115, 98, 1);
color: #fff}
.submit {
    margin-top: 6%;
    margin-left: 45%;
}
.close {
    margin-right: 10px;
    float: right;
}
/deep/.el-icon-close {
    color: #333333;
    font-size: 25px;
}
.kai {
    margin-bottom: 15px;
}
.beizhu {
    // margin-top:12%;
}
/deep/ .radio {
    padding-top: 4%;
}
.fabiao {
    margin-bottom: 1%;
}
/deep/ .el-rate__icon {
    font-size:40px;
}
.rate {
    height:45px;
    margin-bottom: 10px;
}
.success-tip {
    margin: auto;
    width: 369px;
}
.el-tag.el-tag--success {
    font-size: 14px;
}
.gray {
    color:rgb(236, 4, 4)
}
/deep/ .xianzhi .el-textarea__inner {
    border-color: rgb(236, 4, 4);
}
// /deep/ .el-message {
//     top: 41%!important;
//     left: 56%!important;
//     z-index: 3350!important;
// }
</style>
